<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item>YOU ARE HERE</b-breadcrumb-item>
      <b-breadcrumb-item>
        <router-link tag="a" to="/app/applications"> Applications</router-link>
      </b-breadcrumb-item>
      <b-breadcrumb-item class="fw-semi-bold">{{ formName }}</b-breadcrumb-item>
    </b-breadcrumb>

    <b-container fluid>
      <b-tabs content-class="mt-3">
        <b-tab title="Box" @click="handleTabBox">
          <FormMasterBox
            ref="masterBox"
            @loadingHandle="loadingHandleChild"
          />
        </b-tab>
        <b-tab title="Category" @click="handleTabCat">
          <FormMasterCategory
            ref="masterCat"
            @loadingHandle="loadingHandleChild"
          />
        </b-tab>
        <b-tab title="Setup Box" @click="handleTabSet">
          <FormMasterSetupBox
            ref="masterSet"
            @loadingHandle="loadingHandleChild"
          />
        </b-tab>
        <b-tab title="Size" @click="handleTabSize">
          <FormMasterSize
            ref="masterSize"
            @loadingHandle="loadingHandleChild"
          />
        </b-tab>
        <b-tab title="Brand" @click="handleTabBrand">
          <FormMasterBrand
            ref="masterBrand"
            @loadingHandle="loadingHandleChild"
          />
        </b-tab>
        <b-tab title="Material" @click="handleTabMaterial">
          <FormMasterMaterial
            ref="masterMaterial"
            @loadingHandle="loadingHandleChild"
          />
        </b-tab>
        <b-tab title="Quotation" @click="handleTabQuotation">
          <FormMasterQuotation
            ref="masterQuotation"
            @loadingHandle="loadingHandleChild"
          />
        </b-tab>
      </b-tabs>
      <Loader
        v-if="isLoadingData"
        fullPage
        useOverlay
        loader="spinner"
      ></Loader>
    </b-container>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Loader from "@/components/Loader/Loader";
import FormMasterBox from "@/pages/Applications/SalesForce/DataBox/MasterBox";
import FormMasterCategory from "@/pages/Applications/SalesForce/DataBox/MasterCategory";
import FormMasterSetupBox from "@/pages/Applications/SalesForce/DataBox/MasterSetupBox";
import FormMasterSize from "@/pages/Applications/SalesForce/DataBox/MasterSize";
import FormMasterBrand from "@/pages/Applications/SalesForce/DataBox/MasterBrand";
import FormMasterMaterial from "@/pages/Applications/SalesForce/DataBox/MasterMaterial";
import FormMasterQuotation from "@/pages/Applications/SalesForce/DataBox/MasterQuotation";
export default {
  components: {
    FormMasterBox,
    FormMasterCategory,
    FormMasterSetupBox,
    FormMasterSize,
    FormMasterBrand,
    FormMasterMaterial,
    FormMasterQuotation,
    Loader,
  },
  data() {
    return {
      isLoadingData: false,
      formName: "Master Data",
      roles_list: [],

      form: {
        role: null,
        start_limit: null,
        end_limit: null,
        user_nik: null,
        username: null,
      },
    };
  },
  computed: {
    ...mapGetters("session", ["userData"]),
  },
  methods: {
    ...mapActions("session", ["showNotification"]),

    loadingHandleChild(value) {
      this.isLoadingData = value;
    },
    handleTabBox() {
      if (this.$refs.masterBox) {
        this.$refs.masterBox.setData(); // Call setDataBox method in FormMasterBox
      }
    },
    handleTabCat() {
      if (this.$refs.masterCat) {
        this.$refs.masterCat.setData();
      }
    },
    handleTabSet() {
      if (this.$refs.masterSet) {
        this.$refs.masterSet.setData();
      }
    },
    handleTabSize() {
      if (this.$refs.masterSize) {
        this.$refs.masterSize.setData();
      }
    },
    handleTabBrand() {
      if (this.$refs.masterBrand) {
        this.$refs.masterBrand.setData();
      }
    },
    handleTabMaterial() {
      if (this.$refs.masterMaterial) {
        this.$refs.masterMaterial.setData();
      }
    },
    handleTabQuotation() {
      if (this.$refs.masterQuotation) {
        this.$refs.masterQuotation.setData();
      }
    },
  },
};
</script>
<style>
.nav-tabs > .nav-item > .nav-link{
  font-weight: 600;
}
</style>
<style src="../SalesForce.scss" lang="scss" scoped />
